export default [
  {
    type: 'text',
    content:
      'الأهلية: حملة الكاش باك متاحة على خدمة "ادفعها كاملة" لجميع العملاء في السعودية والإمارات، من عمر 18 سنة أو أكثر، على عدد محدد من المتاجر المختارة من قبل تمارا، تحقق من تطبيق تمارا لمعرفة المتاجر التي تقدم خدمة "ادفعها كاملة".',
  },
  {
    type: 'text',
    content:
      'فترة الحملة: حملة الكاش باك متاحة لفترة يتم تحديدها من قبل تمارا، كما تحتفظ تمارا بالحق في تعديل أو إلغاء الحملة دون إشعار مسبق.',
  },
  {
    type: 'text',
    content:
      'المعاملات المؤهلة: يصبح المشاركون في الحملة مؤهلين للحصول على عرض الكاش باك من خلال استخدام خدمة "ادفعها كاملة" المتاحة للمتاجر المختارة من قبل تمارا.',
  },
  {
    type: 'text',
    content:
      'عرض الكاش باك: ستقدم تمارا نسبة مئوية ثابتة للكاش باك على المعاملات المؤهلة، هذه النسبة متغيرة حسب التاجر مع الأخذ بالاعتبار الحد المسموح للكاش باك هو 150 ر.س/د.إ حسب ما تعلنه تمارا. وسيظهر مبلغ الكاش باك في حساب المشترك خلال فترة محددة.',
  },
  {
    type: 'text',
    content:
      'رصيد الاسترداد النقدي / انتهاء الصلاحية / المرتجعات: تُضاف جميع عمليات الاسترداد النقدي إلى محفظة تمارا فقط. وتظهر مبالغ الكاش باك خلال 7 أيام عمل، يتم إضافة جميع الكاش باك إلى محفظة تمارا فقط، خلال 7 أيام عمل. الطلبات الملغاة أو المسترجعة بالكامل أو جزئيًا ليست مؤهلة للحصول على الكاش باك',
  },
  {
    type: 'text',
    content:
      'تنتهي صلاحية الكاش باك بعد مرور 3 (ثلاثة) أشهر من تاريخ إضافة المبلغ إلى حساب المحفظة. وتحتفظ تمارا بالحق في بالقيام بأي تعديلات على الكاش باك بناءً على حالة الطلبات للعملاء مع تمارا وكذلك تغيير مدة أهلية الكاش باك دون أي إشعار مسبق للمستخدمين.',
  },
  {
    type: 'text',
    content:
      'مشاركة التاجر:تحدد تمارا التجار المشاركين بالحملة، كما تحتفظ بالحق في إضافة أو إزالة أي متجر في أي وقت خلال فترة الحملة وفق تقديرها المطلق.',
  },
  {
    type: 'text',
    content:
      'اتصالات الحملة: تمارا ستعلن تفاصيل الحملة من خلال حساباتها على مواقع التواصل الاجتماعي ورسائل البريد الإلكتروني و موقع وتطبيق تمارا.',
  },
  {
    type: 'text',
    content:
      'عمليات الإحتيال: تحتفظ تمارا بالحق في استبعاد أي مشارك في أي نشاط احتيالي أو يقوم بأي تصرف من شأنه أن يؤثر سلبًا على الحملة ويحق لتمارا اتخاذ إجراءات قانونية ضد المشارك.',
  },
  {
    type: 'text',
    content:
      'حل المطالبات: يتفق جميع الأطراف على أن قرار تمارا في حل أي مطالبة تخص الحملة نهائي وحاسم، ويتفهم جميع الأطراف أن هذا لا يمنع حق الأطراف في تصعيد أي مطالبة إلى المحكمة المختصة إذا لزم الأمر.',
  },
  {
    type: 'text',
    content:
      'الحد من المسؤولية: تمارا لن تكون مسؤولة عن أي خسارة أو ضرر نتج من قبل المشاركين بخصوص الحملة. تمارا لن تكون مسؤولة عن أي مشاكل تقنية أو مشاكل متعلقة بوسيلة الدفع أو نظام التاجر المشارك.',
  },
  {
    type: 'text',
    content:
      'قانون الدولة: الشروط والأحكام ستكون خاضعة لقوانين الدولة التي تم ترويج العرض بها',
  },
]
